module.exports = __webpack_public_path__ + "img/image-3.18840fb1.jpg";